import React from 'react';
import { motion } from 'framer-motion';
import { Parallax } from 'react-scroll-parallax';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section section-padding">
      <div className="container">
        <div className="about-grid">
          <Parallax speed={-8} opacity={[0.5, 1]}>
            <motion.div
              className="about-image-container"
              initial={{ opacity: 0, x: -60, scale: 0.95 }}
              whileInView={{ opacity: 1, x: 0, scale: 1 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 1, ease: 'easeOut' }}
            >
              <img
                src="/images/gal17.jpg"
                alt="Heaven Town Homestay"
                className="about-image"
              />
              <motion.div 
                className="about-image-overlay"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.3 }}
              ></motion.div>
            </motion.div>
          </Parallax>

          <Parallax speed={3}>
            <motion.div
              className="about-text-container"
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 1, delay: 0.2, ease: 'easeOut' }}
            >
              <motion.h2 
                className="heading-1"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                A Sanctuary in the Hills
              </motion.h2>
              <div className="content-spacing">
                <motion.p 
                  className="body-large"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  Nestled in the serene hills, The Heaven Town Homestay offers the perfect blend of comfort and nature. Every sunrise feels like a dream.
                </motion.p>
                <motion.p 
                  className="body-regular"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                >
                  Our homestay is more than just a place to stay—it's an experience. Wake up to misty mornings, breathe in the fresh mountain air, and let the tranquility of nature refresh your soul.
                </motion.p>
                <motion.p 
                  className="body-regular"
                  initial={{ opacity: 0, y: 15 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                >
                  Whether you're seeking adventure or relaxation, we provide a warm and welcoming environment where you can truly disconnect and rejuvenate.
                </motion.p>
              </div>
            </motion.div>
          </Parallax>
        </div>
      </div>
    </section>
  );
};

export default About;
